/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { productClick, addToCartEvent } from "../lib/gaEnhancedEcommerce";
import {
  primary_s5_l55,
  primary_s20_l70_a025,
  primary_s15_l20,
  primary_s5_l90,
} from "../lib/colors";
import { jsx, css } from "@emotion/core";
import moment from "moment";

import A from "../Anchor/Anchor";
import Price from "../Price/Price";
import Cart from "../Icons/Cart";

import "./ProductThumbnail.scss";

// import {
//   addToCart,
//   isInCart,
//   quantityInCart,
//   getMaxAddable,
// } from '../../../redux/modules/cart';
const addToCart = () => console.log("addToCart");
const isInCart = () => console.log("addToCart");
const quantityInCart = () => console.log("addToCart");
const getMaxAddable = () => console.log("addToCart");

class ProductThumbnail extends Component {
  addToCart = (event) => {
    event.preventDefault();
    const product = this.props.product;
    this.props.addToCart(product, 1);

    if (this.props.advancedGa) {
      addToCartEvent({
        id: product.code || "",
        name: product.name,
        category: product.categoryName,
        brand: product.brand,
        price: product.price,
        quantity: 1,
      });
    }
  };

  goToProduct = (event) => {
    event.preventDefault();
    const product = this.props.product;
    const productGA = {
      id: product.code,
      name: product.name,
      category: product.categoryName,
      brand: product.brand,
    };

    if (this.props.advancedGa) {
      // GOOGLE ANALYTICS: PRODUCT CLICK
      // THEN ROUTER PUSH
      productClick(productGA, this.props.list);
      this.props.router.push(
        `/${product.type}/${product.categorySeoName}/${
          product.subcategorySeoName ? product.subcategorySeoName : "_"
        }/${product.seoName}`
      );
    } else {
      // JUST ROUTER PUSH
      this.props.router.push(
        `/${product.type}/${product.categorySeoName}/${
          product.subcategorySeoName ? product.subcategorySeoName : "_"
        }/${product.seoName}`
      );
    }
  };

  renderAvailabilityClass() {
    let { product, sellProductsOutOfStock } = this.props;

    if (sellProductsOutOfStock && !product.maxNumInCart) {
      return "available";
    }

    const minAvailable = product.maxNumInCart
      ? Math.min(product.stock, product.maxNumInCart)
      : product.stock;

    if (minAvailable === 0) {
      return "not-available";
    } else if (minAvailable > 0 && minAvailable < 10) {
      return "availability-warning";
    } else {
      return "";
    }
  }

  renderAvailability() {
    let { product, sellProductsOutOfStock } = this.props;

    // è presente una data di disponibilità
    if (!!product.availabilityDate) {
      // la data è nel futuro
      if (new Date(product.availabilityDate) > new Date()) {
        return (
          "Spedizione dal " +
          moment(new Date(product.availabilityDate)).format("DD-MM-YYYY")
        );
      }
    }

    // VENDE FUORI STOCK
    if (sellProductsOutOfStock) {
      if (product.stock === 0) {
        return "Disponibile in 24 ore";
      }
      if (product.maxNumInCart) {
        return `Max ${product.maxNumInCart} pezzi acquistabili`;
      }
      return "Disponibile";
    }

    // NON VENDE FUORI STOCK
    if (product.stock === 0) {
      return "In riordino";
    } else if (product.stock === 1) {
      return "Ultimo pezzo disponibile";
    } else if (product.stock < 10) {
      if (product.maxNumInCart && product.maxNumInCart < product.stock) {
        return `Max ${product.maxNumInCart} pezzi acquistabili`;
      }
      return `Ultimi ${product.stock} pezzi disponibili`;
    }

    // NON VENDE FUORI STOCK E STOCK >= 10
    if (product.maxNumInCart) {
      return `Max ${product.maxNumInCart} pezzi acquistabili`;
    }

    // NON VENDE FUORI STOCK, STOCK >= 10 E NESSUN LIMITE SUI PEZZI ORDINABILI
    return null;
  }

  renderDiscount = (discount, price, listPrice, secondaryColor, uiVariant) => {
    const discountStyle = css`
      & {
        background-color: ${secondaryColor};
        color: ${primary_s15_l20(secondaryColor)};
      }
      &.variant-1 {
        top: -15px;
        right: -15px;
        width: 60px;
        height: 60px;
        padding: 15px 0;
        font-size: 18px;
        border-radius: 50%;
        letter-spacing: 1px;

        span {
          font-size: 19px;
        }
      }
      &.variant-2 {
        top: -1px;
        right: -1px;
        padding: 0 6px 3px;
        font-size: 14px;
        border-bottom-left-radius: 6px;
        letter-spacing: 0.5px;

        span {
          font-size: 15px;
        }
      }
      &.variant-3 {
        top: 10px;
        right: 20px;
        padding: 0 8px 1px;
        font-size: 14px;
        border-radius: 15px;
        letter-spacing: 0.5px;

        span {
          font-size: 15px;
        }
      }
    `;

    if (discount) {
      return (
        <div className={`discount variant-${uiVariant}`} css={discountStyle}>
          {discount.toFixed(0)}
          <span>%</span>
        </div>
      );
    } else if (listPrice - price > 0) {
      const discountPercent = ((100 * (listPrice - price)) / listPrice)
        .toFixed(0)
        .replace(".", ",");

      return (
        <div className={`discount variant-${uiVariant}`} css={discountStyle}>
          {discountPercent}
          <span>%</span>
        </div>
      );
    }

    return null;
  };

  renderAddToCart = (isSmall = false) => {
    return (
      <A
        primary={this.props.primary || this.props.primaryColor}
        href={`#${this.props.id}`}
        className={`add-to-cart ${isSmall ? "small" : ""} ${
          this.props.maxAddable > 0 ? "" : "disabled"
        }`}
        onClick={() => console.log("")}
        >
        {this.props.maxAddable > 0 ? (
          <React.Fragment>
            <span className="lg-writing">
              {this.props.isInCart
                ? "Aggiungi un altro"
                : "Aggiungi al carrello"}
            </span>
            <span className="xs-writing">Aggiungi</span>
            <Cart />
          </React.Fragment>
        ) : (
          <span>In riordino</span>
        )}
      </A>
    );
  };

  render() {
    let {
      product,
      siteName,
      maxAddable,
      // primaryColor,
      // secondaryColor,
      uiVariantThumbnail,
      uiVariant,
      isCountdown = false,
    } = this.props;

    const uiVariantThumbnailToShow = uiVariant || uiVariantThumbnail;
    const primaryColor = this.props.primary || this.props.primaryColor;
    const secondaryColor = this.props.secondary || this.props.secondaryColor;

    const peopleLooking = [0, 0, 0, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 5, 5, 6];
    const randomIndex = Math.floor(Math.random() * peopleLooking.length);

    const thumbnailStyle = css`
      &.variant-1 {
        &:focus,
        &:hover,
        &.active {
          .visible-content {
            box-shadow: 0 10px 10px 10px ${primary_s20_l70_a025(primaryColor)};
          }
          .add-to-cart {
            background-color: ${primaryColor};
            color: #fff;
          }
        }

        &.countdown {
          .description {
            @media (min-width: 992px) {
              padding-right: 25px;
            }
          }
        }

        .visible-content {
          border-radius: 12px;
        }

        .price-availability {
          flex-direction: row;
          align-items: flex-end;
          justify-content: space-between;

          .saving {
            margin: 10px 0 0;
            font-size: 11px;
          }

          .availability {
            text-align: right;
            font-size: 9px;
            text-transform: uppercase;
          }
        }

        .add-to-cart {
          color: "#fff";
          background-color: ${primaryColor};
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 1px;
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;
        }
      }

      &.variant-2 {
        &:focus,
        &:hover,
        &.active {
          .visible-content {
            border: 1px solid ${primary_s5_l90(primaryColor)};
          }
          .add-to-cart {
            background-color: ${primaryColor};
            color: #fff;
          }
        }

        &.countdown {
          .description {
            @media (min-width: 992px) {
              padding-right: 20px;
            }
          }
        }

        .visible-content {
          border: 1px solid ${primary_s5_l90(primaryColor)};
        }

        .price-availability {
          flex-direction: column-reverse;
          align-items: flex-start;
          justify-content: space-between;

          .saving {
            font-size: 10px;
            text-transform: uppercase;

            span {
              font-size: 11px;
            }
          }

          .availability {
            margin-bottom: 10px;
            font-size: 11px;
            min-height: 16px;
          }
        }

        .add-to-cart {
          margin: 0 20px 20px;
          color: "#fff";
          background-color: ${primaryColor};
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 1px;

          &.small {
            margin: 20px 0 0;

            @media (min-width: 992px) {
              display: inline-block;
              padding: 10px 20px;
            }
          }
        }
      }

      &.variant-3 {
        &:focus,
        &:hover,
        &.active {
          .visible-content {
            border: 1px solid ${primary_s5_l90(primaryColor)};
          }
          .add-to-cart {
            background-color: ${primaryColor};
            color: #fff;
          }
        }

        &.countdown {
          .price-availability {
            @media (min-width: 992px) {
              align-items: flex-start;
            }
          }

          .description {
            @media (min-width: 992px) {
              padding-right: 42px;
            }
          }
        }

        .visible-content {
          border: 1px solid transparent;
        }

        .price-availability {
          flex-direction: column-reverse;
          align-items: center;
          justify-content: center;

          .saving {
            font-size: 10px;
            text-transform: uppercase;

            span {
              font-size: 11px;
            }
          }

          .availability {
            margin-bottom: 10px;
            font-size: 11px;
            min-height: 16px;
          }
        }

        .add-to-cart {
          margin: 0 20px 20px;
          color: #4f4f4f;
          background-color: #fff;
          font-size: 12px;
          border: 1px solid ${primaryColor};
          border-radius: 6px;

          &.small {
            margin: 20px 0 0;

            @media (min-width: 992px) {
              display: inline-block;
              padding: 10px 20px;
            }
          }
        }
      }
    `;

    return (
      <div
        className={`product variant-${uiVariantThumbnailToShow} ${
          isCountdown ? "countdown" : ""
        } ${
          product.discount ? "special-offer" : ""
        } ${this.renderAvailabilityClass()}`}
        css={thumbnailStyle}
      >
        <div className="visible-content">
          <A
            primary={primaryColor}
            href={`#${product.name}`}
            className="product-content"
            style={{ color: "#4f4f4f" }}
          >
            <img src={product.image} alt={`${product.name} - ${siteName}`} />

            {this.renderDiscount(
              product.discount,
              product.price,
              product.listPrice,
              secondaryColor,
              uiVariantThumbnailToShow
            )}
            <div className="text-container">
              <div className="description">{product.name}</div>

              <div className="price-availability">
                <div className="price-container">
                  {product.listPrice && product.listPrice > product.price && (
                    <div className="prev-price">
                      <Price amount={product.listPrice} />
                    </div>
                  )}
                  <div className="price">
                    <Price amount={product.price} />
                  </div>
                  {product.listPrice > product.price ? (
                    <div className="saving">
                      Risparmio{" "}
                      <Price amount={product.listPrice - product.price} />
                    </div>
                  ) : (
                    <div>&nbsp;</div>
                  )}
                </div>

                <div
                  className="availability"
                  style={{ color: primary_s5_l55(primaryColor) }}
                >
                  {this.renderAvailability()}
                </div>
              </div>

              {isCountdown &&
                uiVariantThumbnailToShow !== "1" &&
                this.renderAddToCart(true)}
            </div>
          </A>

          {(!isCountdown ||
            (isCountdown && uiVariantThumbnailToShow === "1")) &&
            this.renderAddToCart()}
        </div>
        {peopleLooking[randomIndex] > 0 && (
          <div className="hidden-content">
            {peopleLooking[randomIndex]}{" "}
            {peopleLooking[randomIndex] === 1
              ? "persona sta"
              : "persone stanno"}{" "}
            guardando questo prodotto
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isInCart: false,
    quantityInCart: 0,
    maxAddable: 10,
    siteName: state.store.singleStore.siteName,
    sellProductsOutOfStock: true,
    advancedGa: state.store.singleStore.advancedGa,
    primaryColor: state.store.singleStore.brandColor,
    secondaryColor: state.store.singleStore.secondaryColor,
    uiVariantThumbnail: state.store.singleStore.thumbnail,
  };
}

ProductThumbnail = withRouter(ProductThumbnail);

export default connect(mapStateToProps, { addToCart })(ProductThumbnail);
